export class QuestionCtrlType {
  public static SINGLE_CHOICE = 1;
  public static MULTIPLE_CHOICE = 2;
  public static FREE_TEXT = 3;
  public static NUMBERIC_TEXT = 4;
  public static SELECT_ALL_THAT_APPLY = 5;

}
